// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__ILLKU","wrapper":"Checkbox_wrapper__XdPb4","input":"Checkbox_input__pFxZr","hidden":"Checkbox_hidden__w__6u","label":"Checkbox_label__tFYQY"};